<div class="payment-lists">
  <div class="payment-lists__header">
    <h2 class="payment-lists__title">{{ headerTitleKey() | translate }}</h2>
    <button
      class="payment-lists__close"
      mat-dialog-close
      type="button"
      aria-label="Cerrar"
    >
      <v-one-icon name="close" [color]="'var(--color-gray-700)'" />
    </button>
  </div>

  <v-one-tabs
    [tabs]="tabs()"
    [activeTabId]="initialTabId"
    (tabChange)="onTabChange($event)"
  ></v-one-tabs>

  <ng-template #cashiersTab>
    <app-crud-cashiers
      [listCashiers]="listCashiers"
      [groupCashier]="group"
      [showOwnHeader]="false"
      [showOwnActions]="false"
    ></app-crud-cashiers>
  </ng-template>

  <ng-template #banksTab>
    <app-crud-banks
      [listBanks]="listBanks"
      [groupPayment]="group"
      [showOwnHeader]="false"
      [showOwnActions]="false"
    ></app-crud-banks>
  </ng-template>

  <ng-template #mailsTab>
    <app-crud-mails
      [listMails]="listMails"
      [groupMails]="group"
      [showOwnHeader]="false"
      [showOwnActions]="false"
    ></app-crud-mails>
  </ng-template>
</div>
